import { render, staticRenderFns } from "./SwitchCourseRecord.vue?vue&type=template&id=f4cc6f2a"
import script from "./SwitchCourseRecord.vue?vue&type=script&lang=ts"
export * from "./SwitchCourseRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports